import type { Permissions } from "@/lib/auth/permissions";

export type User = {
  sub: string;
  displayName: string;
  mail: string;
  tenantId: string;
  tenantSlug: string;
};
export type UserGroup = {
  id: string;
  name: string;
  appRoles: Array<{ appId: string; roleName: string }>;
  projectRoles: Array<{ appId: string; roleName: string }>;
};

export type FeatureFlags = {
  usePresence: boolean;
  useRealTimeAnnotations: boolean;
};

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  usePresence: false,
  useRealTimeAnnotations: false,
};

export type AuthContextType = {
  user: User | null | undefined;
  /** Global permissions for proofing flow (no project-specific context) */
  permissions?: Permissions;
  supplierGroups: string[]; // List of group IDs where user has supplier role
  featureFlags?: FeatureFlags;
};
